export * from './api.service';
export * from './actualite.service';
export * from './home.service';
export * from './articles.service';
export * from './auth-guard.service';
export * from './jwt.service';
export * from './user.service';
export * from './context.service';
export * from './search.service';
export * from './nouveaute.service';
export * from './kne-services.service';
export * from './signin.service';
export * from './not-auth.service';
export * from './pager.service';
export * from './cart.service';
export * from './commandes.service';


// WEBPACK FOOTER //
// ./src/app/shared/services/index.ts